import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

import { relativeFills } from "utils/relativeUtils";

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "noOpacity" && prop !== "extended",
})(({ theme, noOpacity, extended }) => ({
  display: "flex",
  position: "relative",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 0,
  margin: "0 auto",
  alignSelf: "center",
  "&:hover": {
    opacity: noOpacity ? 1 : 0.5,
  },
  ...(extended && {
    width: "70%",
    maxWidth: 260,
    [theme.breakpoints.up("mobile")]: {
      width: 260,
    },
    [theme.breakpoints.up("tablet")]: {
      width: "100%",
    },
  }),
  ...relativeFills(theme),
}));

export const Badge = styled(Typography)(({ theme }) => ({
  width: 24,
  height: 24,
  right: "calc(50% - 29px)",
  top: 0,
  position: "absolute",
  borderRadius: "50%",
  border: `2px solid ${theme.palette.primary.light}`,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  [theme.breakpoints.up("mobile")]: {
    right: "calc(50% - 43px)",
    width: 31.1,
    height: 31.1,
  },
}));

export const BlueBadge = styled(Badge)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.light,
  "&:hover": {
    color: theme.palette.cornflowerBlue,
    transform: "scale(1.1)",
  },
}));

export const GreenBadge = styled(Badge)(({ theme }) => ({
  backgroundColor: "white",
  border: `7px solid ${theme.palette.springGreen}`,
  color: theme.palette.springGreen,
}));

export const PartyHat = styled("img")(({ theme }) => ({
  position: "relative",
  height: 56,
  left: 8,
  top: 10,
  zIndex: 999,
  [theme.breakpoints.up("mobile")]: {
    height: 58,
    left: 16,
  },
}));

export const Decor = styled("div")({
  position: "absolute",
  zIndex: 999,
});

export const Balloon = styled(Decor)(({ theme }) => ({
  width: 35,
  height: 78,
  [theme.breakpoints.up("mobile")]: {
    width: 40,
    height: 90,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 46,
    height: 101,
  },
}));

export const BigHeart = styled(Decor)(({ theme }) => ({
  width: 36,
  height: 36,
  [theme.breakpoints.up("mobile")]: {
    width: 46,
    height: 46,
  },
}));

export const SmallHeart = styled(Decor)(({ theme }) => ({
  width: 29,
  height: 29,
  [theme.breakpoints.up("mobile")]: {
    width: 37,
    height: 37,
  },
}));

export const FlowerBouquet = styled("img")(({ theme }) => ({
  position: "absolute",
  zIndex: 999,
  width: 62,
  height: 62,
  [theme.breakpoints.up("mobile")]: {
    width: 69,
    height: 69,
  },
}));

export const Flower = styled("img")(({ theme }) => ({
  position: "absolute",
  zIndex: 999,
  width: 37,
  height: 37,
  [theme.breakpoints.up("mobile")]: {
    width: 46,
    height: 46,
  },
}));

export const FatherHat = styled("img")(({ theme }) => ({
  position: "relative",
  height: 42,
  left: 6,
  top: 14,
  zIndex: 999,
  [theme.breakpoints.up("mobile")]: {
    height: 58,
    top: 17,
    left: 12,
  },
}));

export const BlueBalloon = styled(Balloon)(({ theme }) => ({
  right: "-33px!important",
  [theme.breakpoints.up("mobile")]: {
    right: -16,
  },
}));
